'use client';

import { useTranslations } from 'next-intl';

import { AnimatedButton } from '@/components/ui/animated-button';
import { EmptyState } from '@/components/ui/empty-state';
import { Alert02Icon } from '@/components/ui/icon/glyphs';
import { Link } from '@/i18n/navigation';

export function ProposalGraduatedMarketMissing(): React.ReactNode {
  const t = useTranslations('launchpad.detail');

  return (
    <main className="mx-auto w-full max-w-3xl px-4 py-10">
      <EmptyState
        framed
        size="page"
        icon={Alert02Icon}
        title={t('graduatedMarketMissing')}
        description={t('graduatedMarketMissingDescription')}
        action={
          <AnimatedButton asChild variant="secondary">
            <Link href="/proposals">{t('backToLaunchpad')}</Link>
          </AnimatedButton>
        }
      />
    </main>
  );
}
